import { useAuth } from '@/contexts/AuthContext';
import { useClinicSwitch } from '@/hooks/useClinicSwitch';
import { OrgChooser } from '@careflux/auth';
import { useEffect } from 'react';
import { useLocation } from 'wouter';

const enterApp = () => {
  window.location.href = '/';
};

/** The post-login org choice. A real URL anyone can reach, so a session with
 * nothing to choose between is sent straight on. */
const ClinicSelect = () => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const [, setLocation] = useLocation();
  const {
    memberships,
    currentAccountId,
    switchTo,
    isSwitching,
    pendingAccountId,
    isLoading: membershipsLoading,
    membershipsError,
    hasOtherMembership,
  } = useClinicSwitch({ onEntered: enterApp });

  const nothingToChoose = membershipsError !== null || !hasOtherMembership;

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated) {
      setLocation('/login');
      return;
    }
    if (!membershipsLoading && nothingToChoose) setLocation('/');
  }, [isLoading, isAuthenticated, membershipsLoading, nothingToChoose, setLocation]);

  if (isLoading || membershipsLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-primary border-b-2" />
      </div>
    );
  }

  if (!user || nothingToChoose) {
    return null;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-background to-primary/5">
      <OrgChooser
        memberships={memberships}
        currentAccountId={currentAccountId}
        onSelect={switchTo}
        isSwitching={isSwitching}
        pendingAccountId={pendingAccountId}
        labels={{
          heading: `Velkomin/n, ${user.name?.split(' ')[0] ?? ''}`,
          description: 'Veldu stöð til að halda áfram',
          current: 'Núverandi stöð',
        }}
        logo={<img src="/careflux.png" alt="Careflux" className="h-24 w-auto" />}
        footer={<p className="text-center text-muted-foreground text-xs">Þú getur skipt um stöð síðar í stillingum</p>}
      />
    </div>
  );
};

export default ClinicSelect;
